__turbopack_context__.v({
  "badge": "style-module-scss-module__dw8o8W__badge",
  "badge__partialPayment": "style-module-scss-module__dw8o8W__badge__partialPayment",
  "badge__premium": "style-module-scss-module__dw8o8W__badge__premium",
  "badge__standard": "style-module-scss-module__dw8o8W__badge__standard",
  "partialPayment": "style-module-scss-module__dw8o8W__partialPayment",
});
